import { insertRow } from '@/api/supabaseClient';
import { normalizeContactContext } from '@/lib/contactTracking';
import { anonymizeExitDestination, detectExitType } from '@/lib/exitLinks';

export { detectExitType } from '@/lib/exitLinks';

/**
 * Registra um clique em link de saída (WhatsApp, telefone, email, link externo).
 * Não bloqueia a navegação — dispara os requests de forma assíncrona.
 *
 * @param {string} url - A URL de destino
 * @param {string} label - Label descritivo do link (ex: "WhatsApp Navbar")
 * @param {{ exame?: string, convenio?: string }} context - Contexto opcional do atendimento.
 */
export function trackExitClick(url, label = '', context = {}) {
  const tipo = detectExitType(url);
  if (!tipo) return;

  const pagina = typeof window !== 'undefined' ? window.location.pathname : '';
  const finalLabel = label || tipo;

  // Persistir para o relatório do dashboard sem bloquear a navegação.
  try {
    insertRow('click_externos', {
      destino: anonymizeExitDestination(url),
      tipo,
      label: finalLabel,
      pagina,
      ...normalizeContactContext(context),
    }).catch(() => {});
  } catch {}
}
